import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { DialogWrapper } from '../DialogWrapper';
import { useEscKey } from '../../../hooks/useEscKey';
interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  selectedTicket: any;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  selectedTicket
}) => {
  useEscKey(open, onClose);

  return (
    <DialogWrapper 
      open={open} 
      onClose={onClose}
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'success.main' }}>
          <CheckCircleIcon />
          İşlem Başarılı
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Talep başarıyla oluşturuldu.
        </Typography>
        {selectedTicket && (
          <Typography sx={{ mt: 1, fontWeight: 'bold' }}>
            Talep No: #{selectedTicket.id}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Tamam
        </Button>
      </DialogActions>
    </DialogWrapper>
  );
};